export default "__VITE_ASSET__Dq5bllOm__"